import {
    BankingApi,
    CoreFetch,
    IntegrationApi,
    ProviderIntegrationWebhooksFromJSON,
    RoleApi,
    UserApi
} from '@enter/core';
import _ from 'lodash';
import { equalsFilter } from './util';

export class SettingsService {
    public async listProviderUsers() {
        return CoreFetch<UserApi>(UserApi).listProviderUsers({
            filterActive: _.first(equalsFilter('1')),
        });
    }

    public async listProviderIntegrationApis() {
        return CoreFetch<IntegrationApi>(IntegrationApi).listProviderApiIntegrations({});
    }

    public async listProviderIntegrationHl7s() {
        return CoreFetch<IntegrationApi>(IntegrationApi).listProviderHl7Integrations({});
    }

    public async listProviderIntegrationSftps() {
        return CoreFetch<IntegrationApi>(IntegrationApi).listProviderApplicationSftp({});
    }

    public async listProviderIntegrationTerminals() {
        return CoreFetch<IntegrationApi>(IntegrationApi).listProviderTerminalIntegrations({});
    }

    public async getProviderIntegrationWebhooksUrl() {
        return CoreFetch<IntegrationApi>(IntegrationApi).postProviderIntegrationWebhooks().catch(e => {
            if(e.status === 500) {
                return ProviderIntegrationWebhooksFromJSON("{}");
            } else {
                throw e;
            }
        });
    }

    public async listProviderRoles() {
        return CoreFetch<RoleApi>(RoleApi).listProviderRoles();
    }

    public async listProviderBankingAccounts() {
        return CoreFetch<BankingApi>(BankingApi).listProviderBankingAccounts({});
    }
}
